import { Loader } from 'Components';
import PropTypes from 'prop-types';
import React from 'react';
import './PowerTable.css';
import PowerTableCenter from './PowerTableCenter/PowerTableCenter';
import PowerTableLeft from './PowerTableLeft/PowerTableLeft';
import PowerTableRight from './PowerTableRight/PowerTableRight';
import DeletionContext from 'src/MultiDeletionFunctionality/@state/DeletionStateContext';
import DELETE_ACTIONS from 'src/MultiDeletionFunctionality/@state_manager/actions';

class PowerTable extends React.Component {
   //! Deletion Context:
   static contextType = DeletionContext;

  constructor(props) {
    super(props);
    this.state = {
      leftOffset: 0,
      rightOffset: 0,
    };

    this.leftRef = React.createRef();
    this.rightRef = React.createRef();

    this.handleOffSets = this.handleOffSets.bind(this);
    
  }

  componentDidMount() {
    //! Linking dispatch and deletionState:
    this.dispatch = this.context.dispatch;
    this.deletionState = this.context.deletionState;

    this.handleOffSets();
    this.dispatch({ type: DELETE_ACTIONS.GENERATE_ALLOWED_ITEMS_LIST });
  }

  componentDidUpdate(prevProps) {
    const hasBegunLoading = this.props.isLoading && !prevProps.isLoading;
    this.handleOffSets(hasBegunLoading);
    // this.dispatch({ type: DELETE_ACTIONS.GENERATE_ALLOWED_ITEMS_LIST });
  }

  handleOffSets(hasBegunLoading = false) {
    const leftOffset = this.leftRef.current.clientWidth;
    const rightOffset = this.rightRef.current.clientWidth;

    if (leftOffset !== this.state.leftOffset && !hasBegunLoading) {
      this.setState({ leftOffset });
    }

    if (rightOffset !== this.state.rightOffset && !hasBegunLoading) {
      this.setState({ rightOffset });
    }
  }

  render() {
    return (
      <div className="power-table">
        { this.props.isLoading && <Loader /> }
        <PowerTableLeft
          leftRef={this.leftRef}
          leftOffset={this.state.leftOffset}
          {...this.props}
        />
        <PowerTableCenter
          leftOffset={this.state.leftOffset}
          rightOffset={this.state.rightOffset}
          {...this.props}
        />
        <PowerTableRight
          rightRef={this.rightRef}
          {...this.props}
        />
      </div>
    );
  }
}

PowerTable.propTypes = {
  keys: PropTypes.arrayOf(PropTypes.string),
  data: PropTypes.arrayOf(PropTypes.shape({})),
  isLoading: PropTypes.bool,
  moreVertHelperText: PropTypes.string,
};

PowerTable.defaultProps = {
  keys: [],
  data: [],
  moreVertHelperText: '',
};

export default PowerTable;



// WEBPACK FOOTER //
// ./src/components/PowerTable/PowerTable.jsx